import {useSyncExternalStore} from 'react';
import {translations} from './translations';
import extra from './extra.json';
import backend from './backend.json';
import common from './common.json';
const dictionary={};
function collect(ar,en){for(const key of Object.keys(ar||{})){if(typeof ar[key]==='string'&&typeof en?.[key]==='string')dictionary[ar[key]]=en[key];else if(ar[key]&&typeof ar[key]==='object')collect(ar[key],en?.[key]);}}
collect(translations.ar,translations.en);Object.assign(dictionary,extra,backend,common);
const reverse=Object.fromEntries(Object.entries(dictionary).map(([ar,en])=>[en,ar]));
let language='ar';
try{language=localStorage.getItem('rehlaty_language')==='en'?'en':'ar';}catch{}
const listeners=new Set();
export function setLocale(value){language=value==='en'?'en':'ar';listeners.forEach(fn=>fn());}
export function useLocale(){return useSyncExternalStore(fn=>{listeners.add(fn);return()=>listeners.delete(fn);},()=>language,()=> 'ar');}
export function direction(){return language==='ar'?'rtl':'ltr';}
export function localizedField(object,key){if(!object)return undefined;const original=object[key];if(language!=='en')return original;const alternative=key.endsWith('_ar')?key.slice(0,-3)+'_en':key+'_en';return object[alternative]||original;}
export function tr(value){
 if(typeof value!=='string')return value;
 const key=value.trim();const translated=language==='en'?dictionary[key]:reverse[key];
 if(translated)return value.replace(key,translated);
 const prefixes=['اعتماد فاتورة ','تحصيل فاتورة ','شراء خدمة من الموقع #','طلب شراء من الموقع: ','شراء: ','عكس سند ','عكس '];
 for(const ar of prefixes){const en=dictionary[ar];if(!en)continue;const from=language==='en'?ar:en;const to=language==='en'?en:ar;if(value.startsWith(from))return to+value.slice(from.length);}
 return value;
}
